import { Box, Typography } from "@mui/material";
import Copyright from "./copyright";
import { brandingColors } from "./utils";
import "./footer.css";
import SocialMediaComponent from "./footer/social-media";
import { Link } from "react-router-dom";

export default function FooterComponent(): JSX.Element {
  return (
    <Box className="footer"
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "12px 0 48px 0",
        }}
      >
        {/* centre */}
        <Box className="footer-container"
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
          }}
        >
          <Box className="wrapper"
            sx={{
              margin: "10px 0px",
              padding: "0px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "row", md: "row" },
                justifyContent: "space-between",
                color: brandingColors["green-font"],
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                  width: "50%",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "column" },
                    justifyContent: "space-around",
                  }}
                >
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <a href="/">
                      <img
                        alt=""
                        src="/assets/site-logo.png"
                        width="100%"
                        style={{ objectFit: "cover", maxWidth: "150px" }}
                      />
                    </a>
                  </Box>
                  <Box
                    sx={{
                      padding: "20px 0",
                    }}
                  >
                    <Typography variant={"subtitle2"}>
                      We are the first AI-powered beauty recommandation platform
                    </Typography>
                  </Box>
                  <SocialMediaComponent />
                </Box>
              </Box>
              <Box className="column-2"
                sx={{
                  padding: "10px 20px",
                  width: "50%",
                  borderRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "column" },
                    justifyContent: "space-around",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: { xs: "row", md: "row" },
                      justifyContent: "space-between",
                      color: brandingColors["green-font"],
                    }}
                  >
                    <Box
                      sx={{
                        padding: "10px 0px 10px 20%",
                        width: "100%",
                        borderRadius: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          padding: "10px 0",
                        }}
                      >
                        <Link to="/about">About us</Link>
                      </Box>
                      <Box
                        sx={{
                          padding: "10px 0",
                        }}
                      >
                        <Link to="/about#work-with-us">Work With us</Link>
                      </Box>

                      <Box
                        sx={{
                          padding: "10px 0",
                        }}
                      >
                        <Link to="/privacy">Privacy policy</Link>
                      </Box>
                      <Box
                        sx={{
                          padding: "10px 0",
                        }}
                      >
                        <Link to="/cookie">Cookies</Link>
                      </Box>
                      <Box
                        sx={{
                          padding: "10px 0",
                        }}
                      >
                        <Link to="/terms-of-service">Terms of Service</Link>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Copyright />
          </Box>
        </Box>
    </Box>
  )
}